module.exports = __webpack_public_path__ + "img/digithia-logo.fac8abd0.png";